<template>
    <!-- Contextual push opt-in for the #experience tab. Never auto-prompts:
         the browser permission dialog only ever opens from the button click. -->
    <div class="push-optin" v-if="visible">
        <template v-if="state === 'ios-needs-install'">
            <div class="columns is-mobile is-gapless">
                <div class="column is-narrow mr-3"><i class="fal fa-mobile is-size-4"></i></div>
                <div class="column">
                    Get trip alerts on your iPhone: tap the Share icon in Safari, choose
                    <strong>Add to Home Screen</strong>, and open Tennis Ventures from there.
                </div>
                <div class="column is-narrow">
                    <a @click="dismiss"><i class="fas fa-times has-text-grey"></i></a>
                </div>
            </div>
        </template>

        <template v-else-if="state === 'denied'">
            <div class="is-size-7 has-text-grey">
                <i class="fas fa-bell-slash mr-2"></i>Notifications are blocked for this site — you can
                enable them in your browser settings.
            </div>
        </template>

        <template v-else-if="state === 'available'">
            <div class="columns is-mobile is-gapless">
                <div class="column is-narrow mr-3"><i class="fal fa-bell is-size-4"></i></div>
                <div class="column">
                    Get schedule changes and announcements as notifications on this device.
                </div>
                <div class="column is-narrow ml-3">
                    <b-button type="is-primary" size="is-small" :loading="working" @click="enable">Enable</b-button>
                </div>
                <div class="column is-narrow ml-2">
                    <a @click="dismiss"><i class="fas fa-times has-text-grey"></i></a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import * as push from '@/push';

    const DISMISS_KEY = 'push-optin-dismissed';

    export default {
        name: 'PushOptIn',
        data: function() {
            return {
                state: 'hidden', // hidden | available | ios-needs-install | denied
                working: false,
                dismissed: localStorage.getItem(DISMISS_KEY) === '1'
            };
        },
        computed: {
            visible: function() {
                if (this.state === 'hidden') return false;
                // The install hint and enable card are dismissible; the
                // denied notice only shows if they previously engaged.
                if (this.dismissed && this.state !== 'denied') return false;
                return true;
            }
        },
        methods: {
            evaluate: function() {
                const cap = push.capability();
                if (cap === 'unsupported') {
                    this.state = 'hidden';
                } else if (cap === 'ios-needs-install') {
                    this.state = 'ios-needs-install';
                } else if (push.permission() === 'denied') {
                    // Only nag about denial if they didn't just ignore us.
                    this.state = this.dismissed ? 'hidden' : 'denied';
                } else {
                    // granted-but-unsubscribed still needs the button.
                    push.getSubscription().then(sub => {
                        this.state = sub ? 'hidden' : 'available';
                    });
                }
            },
            enable: function() {
                this.working = true;
                push.subscribe().then(() => {
                    this.working = false;
                    this.state = 'hidden';
                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Notifications On',
                        text: 'You\'ll get trip updates on this device.'
                    });
                }).catch(() => {
                    this.working = false;
                    this.evaluate();
                });
            },
            dismiss: function() {
                localStorage.setItem(DISMISS_KEY, '1');
                this.dismissed = true;
            }
        },
        mounted() {
            this.evaluate();
        }
    };
</script>

<style lang="scss" scoped>
    .push-optin {
        background-color: white;
        border-radius: 0.3rem;
        padding: 0.8rem 1rem;
        font-size: 0.9rem;

        .columns {
            align-items: center;
        }
    }
</style>
